<div class="used-car-gallery-cta" [@slideContent]="animationState" (@slideContent.done)="onAnimationEvent($event)">
    <header class="used-car-gallery-cta-header">
        <button
            class="button--close used-car-gallery-cta-header__close"
            aria-label="Luk navigation"
            (click)="close()"
            [innerHTML]="closeLightIcon | safe: 'html'"
        ></button>
    </header>
    <div class="used-car-gallery-cta-content">
        <h1 class="used-car-gallery-cta__heading" *ngIf="car$ | async as car">{{ car.make?.value }} {{ car.model?.value }}</h1>
        <h2 class="h3 used-car-gallery-cta__headline">{{ 'used_car_details.gallery_cta_headline' | translate }}</h2>
        <button type="button" class="button--primary" (click)="goToFinancing()">{{ 'used_car_details.buy_the_car' | translate }}</button>
        <button type="button" class="button--primary used-car-gallery-cta-content__book-test-drive" (click)="openTestDriveSidePanel()">
            {{ 'buttons.book_test_drive' | translate }}
        </button>
        <a class="used-car-gallery-cta__link" *ngIf="link$ | async as link" [routerLink]="link.url" (click)="onLinkClick()">{{ link.name }}</a>
    </div>
</div>
